import React, { useEffect } from "react";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { useContent } from "../../hooks/useContent";

const Home = () => {
  const navigate = useNavigate();
  const { setPageHeading } = useContent();

  const boxes = [
    {
      title: "Create Company Account",
      icon: "mdi:office-building",
      link: "/create-company",
      color: "var(--primary-color)",
    },
    {
      title: "Edit Company Account",
      icon: "mdi:account-edit",
      link: "/manage-companies",
      color: "#6c63ff",
    },
    {
      title: "Create Support Ticket",
      icon: "mdi:ticket-account",
      link: "/support-tickets",
      color: "#c77dff",
    },
    {
      title: "Partner Reference",
      icon: "mdi:file-document",
      link: "http://partnerreference.myveekrypt.com",
      color: "#845ef7",
    },
    {
      title: "Email Support",
      icon: "mdi:email",
      link: "/email-support",
      color: "#91a7ff",
    },
    {
      title: "Web Conference",
      icon: "mdi:video",
      link: "/meetings",
      color: "#4dabf7",
    },
  ];

  const handleClick = (link) => {
    if (link.startsWith("http")) {
      window.open(link, "_blank", "noopener noreferrer");
    } else {
      navigate(link);
    }
  };

  useEffect(() => {
    setPageHeading("Partner Portal");
  }, [])

  return (
    <div className="Home">
      <div className="row row-cols-2 row-cols-md-3 g-4 justify-content-center">
        {boxes.map((box, index) => (
          <div key={index} className="col">
            <div
              className="action-box text-center"
              style={{ borderTopColor: box.color, cursor: "pointer" }}
              onClick={() => handleClick(box.link)}
            >
              <div
                className="icon-circle mx-auto"
                style={{ backgroundColor: `${box.color}15` }}
              >
                <Icon icon={box.icon} width="36" color={box.color} />
              </div>
              <h6>{box.title}</h6>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
